@if (app.manufacturerUtils.pcnHistoryDocs.length > 0) {
  <button
    class="btn btn-sm btn-clean pull-right mb-3"
    (click)="app.manufacturerUtils.exportTables()"
    >
    <i class="fa fa-download"></i>&nbsp;
    {{ app.text.manufacturer.export }}
  </button>
}
<!-- <app-paginator
[length]="app.manufacturerUtils.pcnHistoryDocs.length"
[index]="app.paginator.focus"
(focus)="app.paginator.focus = $event"
></app-paginator> -->
<div
  class="tableFixHead clear"
  [ngClass]="{ 'min-height': app.manufacturerUtils.pcnHistoryDocs.length >= 2 }"
  >
  <table class="table table-striped">
    <thead>
      <tr>
        @for (column of cleanedColumns; track column) {
          <th class="p-1 left-align">
            {{ app.field.getLabel("manufacturer." + column) }}
          </th>
        }
      </tr>
      <tr>
        @for (column of cleanedColumns; track column) {
          <th class="p-1">
            @if (app.filterTable.getFilterTableColumns(column)) {
              <div>
                <app-filter-table
                  [column]="column"
                  [columns]="cleanColumns"
                  [docType]="'manufacturer'"
                  [cleanDocs]="app.manufacturerUtils.cleanHistoryDocs"
                  [selectedFilters]="selectedFilters"
              (resultedDocs)="
                app.filterTable.getFilterResults($event, 'manufacturer')
              "
                  [resetComponent]="resetFilterInputsObservable"
                  >
                </app-filter-table>
              </div>
            }
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (doc of app.paginator.getPageWithDoc(); track doc) {
        <tr>
          @for (column of cleanedColumns; track column) {
            <td class="p-1">
              @if (
                column !== 'pcnTypeOfChange' &&
                column !== 'pcnSource' &&
                column !== 'pcnEffectiveDate'
                ) {
                <span
                  >{{ doc[column] }}</span
                  >
                }
                @if (column === 'pcnTypeOfChange') {
                  <span class="pcnTypeOfChange">
                    {{ getPcnTypeOfChange(doc[column]) }}
                  </span>
                }
                @if (column === 'pcnEffectiveDate' && doc[column] != null) {
                  <span
                    class="pcnTypeOfChange"
                    >
                    {{ doc[column] }}
                  </span>
                }
                @if (
                  app.table.getColumnTypeDisplay(column) === 'link' && doc[column]
                  ) {
                  <span
                    >
                    <a [href]="doc[column]" target="_blank">
                      <i class="fas fa-file icon-blue"></i>
                    </a>
                  </span>
                }
              </td>
            }
          </tr>
        }
        <tr>
          @if (app.manufacturerUtils.pcnHistoryLoading) {
            <td
              colspan="99"
              class="text-center"
              >
              {{ this.app.text.core.loading }}
            </td>
          }
          @if (
            !app.manufacturerUtils.pcnHistoryLoading &&
            app.manufacturerUtils.pcnHistoryDocs.length === 0
            ) {
            <td
              colspan="99"
              class="text-center"
              >
              {{ app.text.app.noResults }}
            </td>
          }
        </tr>
      </tbody>
    </table>
  </div>
  <!-- <app-paginator
  [length]="app.manufacturerUtils.pcnHistoryDocs.length"
  [index]="app.paginator.focus"
  (focus)="app.paginator.focus = $event"
></app-paginator> -->
